import {
  GetMatchesResponse,
  GetMatchesErrorResponse,
  RequestContactResponse,
  RequestContactErrorResponse,
  FilterOptions,
} from "./types";

const API_URL = import.meta.env.VITE_API_URL || "";

export interface FetchMatchesParams {
  postingId: string;
  page?: number;
  limit?: number;
  filters?: Partial<FilterOptions>;
}

export async function fetchMatches({
  postingId,
  page = 1,
  limit = 20,
  filters,
}: FetchMatchesParams): Promise<GetMatchesResponse> {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));

  if (filters) {
    if (filters.subjects && filters.subjects.length > 0) {
      filters.subjects.forEach((s) => params.append("subjects", s));
    }
    if (filters.levels && filters.levels.length > 0) {
      filters.levels.forEach((l) => params.append("levels", l));
    }
    if (filters.scheme && filters.scheme.length > 0) {
      filters.scheme.forEach((s) => params.append("scheme", s));
    }
    if (filters.minExperience !== null && filters.minExperience !== undefined) {
      params.set("minExperience", String(filters.minExperience));
    }
  }

  const url = `${API_URL}/api/postings/${postingId}/matches?${params.toString()}`;
  const response = await fetch(url);

  if (!response.ok) {
    const error: GetMatchesErrorResponse = await response.json();
    throw new Error(error.error);
  }

  return response.json();
}

export async function requestContact(
  postingId: string,
  applicantId: string
): Promise<RequestContactResponse> {
  const url = `${API_URL}/api/postings/${postingId}/request-contact`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ applicantId }),
  });

  if (!response.ok) {
    const error: RequestContactErrorResponse = await response.json();
    throw new Error(error.error);
  }

  return response.json();
}
